import { components } from "@opstel/gen/api/v2";
import { DateTime, Duration, Interval } from "luxon";
import { z } from "zod";

export const dateTimeSchema = z.iso
  .datetime()
  .transform((dt) => DateTime.fromISO(dt))
  .refine((d) => d.isValid, "Invalid timestamp");

export const durationSchema = z
  .string()
  .transform((d) => Duration.fromISOTime(d))
  .refine((d) => d.isValid, "Invalid duration");

export const intervalSchema = z
  .object({ startTime: dateTimeSchema, endTime: dateTimeSchema })
  .transform((interval) => Interval.fromDateTimes(interval.startTime, interval.endTime))
  .refine((interval) => interval.isValid) satisfies z.ZodType<
  Interval<true>,
  components["schemas"]["TimeInterval"]
>;
